/* unplugin-vue-components disabled */import { render } from "./ConfirmTemplate.vue?vue&type=template&id=f389cb22"
import script from "./ConfirmTemplate.vue?vue&type=script&lang=js"
export * from "./ConfirmTemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__